import { css } from 'styled-components';
import { mobileWidth } from './sizes';

export const mobile = inner => css`
	@media (max-width: ${mobileWidth}px) {
		${inner};
	}
`;
